import { Form, FormGroup } from '@southfields-digital/mxmz-react-ui';

import { LocalProperties } from 'src/components/GraphicDetails/utils';

import PropertyField from '../PropertyField';

import styles from './GraphicPropertiesForm.module.scss';

interface IGraphicPropertiesFormProps {
  properties: LocalProperties | null;
  handleChangeGraphicProperties: (properties: LocalProperties) => void;
  handleSelectMedia: (
    properties: ImageProperties,
    handleSelectValue?: (value: string) => void
  ) => void;
}

export default function GraphicPropertiesForm({
  handleSelectMedia,
  properties,
  handleChangeGraphicProperties,
}: IGraphicPropertiesFormProps) {
  const handleChange = (props: WithValue, value: string | number | PropertyValue[]) => {
    handleChangeGraphicProperties({
      ...properties,
      [props.id]: { ...props, value },
    });
  };

  if (!properties) return null;

  const filteredProperties = Object.values(properties).filter(
    (props) => props.type !== 'matchControl' && props.type !== 'clock'
  );

  return (
    <div className={styles.Container}>
      <Form className={styles.Form} onSubmit={() => {}} key={'form'}>
        {filteredProperties.map((props) => {
          const { id, name, type } = props;
          const isRepeater = type === 'repeater';
          const className = isRepeater ? styles.RepeaterWrapper : styles.ElementWrapper;

          return (
            <FormGroup label={isRepeater ? name : name} key={id} htmlFor={id} className={className}>
              <PropertyField
                field={props}
                onChange={(value) => handleChange(props, value)}
                onSelectMedia={handleSelectMedia}
              />
            </FormGroup>
          );
        })}
      </Form>
    </div>
  );
}
